<div [ngClass]="{'disabled': Disabled}">
    
    <div [id]="QuillId" class="w100 quill-editor" [hidden]="!QuillEditor"> </div>

    <textarea id="quill-editor-area" class="full" [hidden]="QuillEditor"></textarea>
</div>